import React from 'react';

import Icon from 'components/Icon/Icon';
import {useDispatch} from 'react-redux';
import {switchSortOrderAC} from 'store/beerStyles/beerStyleSlice';

export const BeerStylesTableHeader = () => {
  const dispatch = useDispatch();

  const handleSwitchOrder = () => dispatch(switchSortOrderAC());

  const tableHeaderCells: {
    name: string;
    className?: string;
    sort?: JSX.Element;
  }[] = [
    {
      name: 'Style',
      className: 'breweries-table__head-name',
      sort: (
        <button className="pub-pages-table__sort" onClick={handleSwitchOrder}>
          <Icon icon="sort-2" />
        </button>
      ),
    },
    {name: 'IBU'},
    {name: 'ABV (%)'},
    {name: '', className: 'breweries-table__head-empty'},
  ];

  return (
    <div className="beer-styles-table__head">
      {tableHeaderCells.map((tableCell) => {
        return (
          <div key={tableCell.name} className={tableCell.className || ''}>
            {tableCell.name} {tableCell.sort || <></>}
          </div>
        );
      })}
    </div>
  );
};
